module.exports = __webpack_public_path__ + "img/app8.591d5420.png";